export default function productStockManagement() {
	jQuery(function ($: JQueryStatic) {
		function isProductPage() {
			return $('body').hasClass('single-product')
		}

		function hasVariations() {
			return $('.variations_form').length > 0
		}

		function resetStockMessage() {
			$('.single_variation_wrap').find('.stock').remove()
		}

		function getStockMessage(inStock: boolean) {
			if (inStock) {
				return '<p class="stock in-stock">Dostępny</p>'
			} else {
				return '<p class="stock out-of-stock">Brak w magazynie</p>'
			}
		}

		function resetInstockSubscriptionForm() {
			$('.cwginstock-subscribe-form').remove()
		}

		function setButtonDisabled(disabled: boolean, button: JQuery<HTMLElement> | null = null) {
			if (!button) return
			if (disabled) {
				$(button).addClass('btn-disabled')
				$(button).attr('disabled', 'disabled')
			} else {
				$(button).removeClass('btn-disabled')
				$(button).removeAttr('disabled')
			}
		}

		if (!isProductPage() && !hasVariations()) return

		$(document.body).on('show_variation', function (event, variation) {
			resetStockMessage()
			resetInstockSubscriptionForm()
			console.log(variation.is_in_stock)
			console.log(getStockMessage(variation.is_in_stock))
			const $variationWrap = $(event.target).closest('.single_variation_wrap')

			let availabilityHtml =
				variation.availability_html === ''
					? getStockMessage(variation.is_in_stock)
					: variation.availability_html

			$(availabilityHtml).insertAfter($variationWrap.find('.woocommerce-variation'))

			setButtonDisabled(!variation.is_in_stock, $('.single-product-add-to-card .btn.btn-primary'))
		})
	})
}
